import React from 'react';
import { colorConstants } from 'config/colorConstants';

const TrashIcon = ({
    width = 16,
    height = 16,
    fill = colorConstants.growthDown,
    className,
}: {
    width?: number;
    height?: number;
    fill?: string;
    className?: string;
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
            aria-hidden
            style={{ flexShrink: 0 }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.33398 2.00004C5.33398 1.63185 5.63246 1.33337 6.00065 1.33337H10.0007C10.3688 1.33337 10.6673 1.63185 10.6673 2.00004C10.6673 2.36823 10.3688 2.66671 10.0007 2.66671H6.00065C5.63246 2.66671 5.33398 2.36823 5.33398 2.00004ZM3.32881 3.33337H2.00065C1.63246 3.33337 1.33398 3.63185 1.33398 4.00004C1.33398 4.36823 1.63246 4.66671 2.00065 4.66671H2.71028L3.13808 11.0837C3.17165 11.5873 3.19942 12.0041 3.24923 12.3433C3.30109 12.6965 3.38335 13.0192 3.55471 13.32C3.82147 13.7883 4.22384 14.1647 4.7088 14.3998C5.02033 14.5507 5.34785 14.6113 5.70371 14.6396C6.04551 14.6667 6.4632 14.6667 6.96794 14.6667H9.03336C9.5381 14.6667 9.95579 14.6667 10.2976 14.6396C10.6535 14.6113 10.981 14.5507 11.2925 14.3998C11.7775 14.1647 12.1798 13.7883 12.4466 13.32C12.618 13.0192 12.7002 12.6965 12.7521 12.3433C12.8019 12.004 12.8297 11.5872 12.8632 11.0836L13.291 4.66671H14.0007C14.3688 4.66671 14.6673 4.36823 14.6673 4.00004C14.6673 3.63185 14.3688 3.33337 14.0007 3.33337H12.6725C12.6686 3.33334 12.6647 3.33334 12.6608 3.33337H3.34048C3.3366 3.33334 3.33271 3.33334 3.32881 3.33337ZM11.9547 4.66671H4.04658L4.4667 10.9686C4.50248 11.5052 4.52721 11.8689 4.56842 12.1496C4.60845 12.4222 4.65735 12.5619 4.71323 12.66C4.84661 12.8942 5.0478 13.0824 5.29028 13.1999C5.39188 13.2491 5.53455 13.2886 5.80922 13.3104C6.092 13.3329 6.45655 13.3334 6.99442 13.3334H9.00688C9.54475 13.3334 9.9093 13.3329 10.1921 13.3104C10.4667 13.2886 10.6094 13.2491 10.711 13.1999C10.9535 13.0824 11.1547 12.8942 11.2881 12.66C11.344 12.5619 11.3929 12.4222 11.4329 12.1496C11.4741 11.8689 11.4988 11.5052 11.5346 10.9686L11.9547 4.66671Z"
                fill={fill}
            />
        </svg>
    );
};

export default TrashIcon;
